import { ROOT_NODE, type Node, type NodeHelpersType } from '@craftjs/core';
import SharedIcon, { type IconProps } from '@builder4/shared/components/Icon';
import { getBreakpointProp } from '@builder4/shared/utils/breakpointUtils';
import type { ContainerProps } from '@builder4/shared/components/Container';
import { InspectorIcon } from '@/components/inspector/InspectorIcon/InspectorIcon';

export const Icon = (props: Partial<IconProps>) => {
  return <SharedIcon {...props} />;
};

Icon.craft = {
  ...SharedIcon.craft,
  related: {
    toolbar: InspectorIcon,
  },
  rules: {
    canDrag: (node: Node, helpers: NodeHelpersType) => {
      if (node.data.custom.isLocked) return false;
      const breakpoint = helpers(ROOT_NODE).get().data.props.breakpoint || 'desktop';
      const position = getBreakpointProp(
        node.data.props as Partial<ContainerProps>,
        'position',
        breakpoint,
      );

      return position === 'relative' || position === 'sticky';
    },
  },
};

export default Icon;
